<template>
    <div>

        <Row :gutter="10">
            <Col span="4">
                <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: cityFilter}"
                             :debounce="500" :skip="skipCity">
                    <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else>
                            <AutoComplete placeholder="Order City" v-model="city" :clearable="true" element-id="city"
                                          @on-clear="onClearCity()" @on-search="onSearchCity($event)">
                                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                                    <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city)">{{cityObj.city}}</div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </template>
                </ApolloQuery>
            </Col>
            <Button @click="onAddContractor" style="float: right;">Add Contractor</Button>
            <Button v-if="isAdmin" @click="exportContractors" :loading="exportLoading" style="float: right;margin-right: 5px">Export CSV</Button>
        </Row>

        <Spin fix size="small" v-if="skipContractors"></Spin>
        <hot-table :settings="hotSettings" v-show="!skipContractors" style="margin: 20px 0 0 0"  ref="hotTableComponent">
            <hot-column v-for="(colset, index) in columns" :settings="colset" :key="index">
            </hot-column>
        </hot-table>
        <Page :total="contractorsCount" :current="pageNumber" show-sizer @on-change="onChangePage" @on-page-size-change="onChangeSize"></Page>

      <add-contractor ref="contractor-form"></add-contractor>

    </div>
</template>

<script>
    import {Constants} from "../../Constants/Constant"
    import {generateHotSettings} from "../ExcelFormattedOrders/Settings"
    import {SEARCH_CITY2} from "../../graphql/queries/territories"
    import {SUBSCRIBE_CONTRACTORS_TOTALCOUNT, SUBSCRIBE_EXCEL_CONTRACTORS} from "../../graphql/subscription/contractor"
    import { HotTable, HotColumn } from '@handsontable/vue'
    import AddContractor from "./AddContractor";
    import {
      addressRenderer,
      contractorNameRenderer,
      statusRenderer,
      actionRenderer,
      contractType,
      getContractorStatusString
    } from "./RendererFunctions";
    import {getAddressString} from "../ExcelFormattedOrders/RendererFunctions";
    import {DELETE_CONTRACTOR} from "../../graphql/mutations/vehicle";
    import moment from 'moment';
    import {GET_ALL_CONTRACTORS} from "../../graphql/queries/contractor";

    export default {
        name: "ExcelContractors",
        components: {HotTable, HotColumn, AddContractor},
        props:['globalSearch'],
        apollo: {
            $subscribe: {
              contractorsCount: {
                    query: SUBSCRIBE_CONTRACTORS_TOTALCOUNT,
                    skip(){return this.skipContractors},
                    variables () {
                        return {
                            city: this.selectedCity,
                            searchFilter: '%' + this.globalSearch + '%'
                        }
                    },
                    result ({ data }) {
                      this.contractorsCount = data.contractorsCount.aggregate.count;
                      //Actually calling below method isn't the efficient way as
                      // it make graphql calls two times [filter change & offset change]
                      this.onChangePage(1);                                             //Reset offset
                      this.$emit('onCount', this.contractorsCount);
                    },
                },
              contractors: {
                    query: SUBSCRIBE_EXCEL_CONTRACTORS,
                    skip(){return this.skipContractors},
                    variables () {
                        return {
                            city: this.selectedCity,
                            searchFilter: '%' + this.globalSearch + '%',
                            offset: this.offset,
                            limit: this.limit
                        }
                    },
                    result ({ data }) {
                        this.contractors = data.contractors
                        this.prepareSheetData(data.contractors)
                    },
                }
            },
        },
        data: function () {
            return {
                Constants: Constants,
                query_SEARCH_CITY: SEARCH_CITY2,
                contractorsCount: 0,
                contractors: [],
                pageNumber: 1,
                offset: 0,
                limit: 10,
                skipContractors: true,
                city: '',
                skipCity: true, //To Avoid calls at initial
                cityFilter: '%%',
                selectedCity: null,                               //[{city: "Surat"}]
                columns: [
                    //table_key_intermediate
                    {title: 'City', data: 'city'},
                    {title: 'Contract<br> Type', data: 'type'},
                    {title: 'Contract<br> Number', data: 'contractorCode'},
                    {
                        title:'Contractor<br> Name',
                        data: 'contractorName',
                        renderer: (...args) => contractorNameRenderer(...args, this)
                    },
                    {
                        title:'Mobile',
                        data: 'contractorMobile'
                    },
                    {
                        title:'Email Id',
                        data: 'contractorEmail'
                    },
                    {
                        title:'Address',
                        data: 'contractorAddress',
                        renderer: addressRenderer
                    },
                    {
                        title:'GST No.',
                        data: 'contractorGSTIN'
                    },
                    {
                        title:'PAN No.',
                        data: 'contractorPAN'
                    },
                    {
                        title:'No. of<br> Vehicles',
                        data: 'numOfVehicles',
                        type: 'numeric'
                    },
                    {
                        title:'No. of<br> Drivers',
                        data: 'numOfDrivers',
                        type: 'numeric'
                    },
                    {
                        title:'Tempo<br> Orders',
                        data: 'numOfTempoOrders',
                        type: 'numeric'
                    },
                    {
                        title:'Pickup<br> Orders',
                        data: 'numOfPickupOrders',
                        type: 'numeric'
                    },
                    {
                        title:'Total<br> Billing',
                        data: 'totalBilling',
                        type: 'numeric'
                    },
                    {
                        title:'Due<br> Payment',
                        data: 'duePayment',
                        type: 'numeric'
                    },
                    {
                        title:'Status',
                        data: 'status',
                        renderer: statusRenderer
                    },
                    {
                        title:'Action',
                        data: 'action',
                        renderer: (...args) => actionRenderer(...args, this, 'contractors', 'onEditContractor', 'onDeleteContractor'),
                        excludeInExport: true
                    },
                ],
                hotSettings: generateHotSettings([80, 100, 100, 125, 90, 170, 170, 125, 100, 100, 100, 90, 90, 90, 100, 90, 100]),
                contractType: { 'ON_CONTRACT': 'On Contract', 'RENTED': 'Rented'},
                exportLoading: false
            }
        },
        computed: {
          isAdmin: function(){
            return this.$store.state.userObj.role[0].id === Constants.adminRoleId
          }
        },
        methods: {
            onChangePage(page){
              this.offset = (page -1) * this.limit;
              this.pageNumber = page;
            },
            onChangeSize(size){
              this.limit = size;
              this.offset = (this.pageNumber -1) * this.limit;
            },
            onSearchCity(event){
                this.cityFilter = '%' + this.city + '%';
                this.skipCity = false;
            },
            onSelectCity(city){
                this.selectedCity = city
            },
            onClearCity(){
                this.selectedCity = null
            },
            prepareSheetData(data, forExport){
                let mainArr = []
                data.forEach(curnt => {
                    curnt.obj = {
                        city: curnt.city,
                        type: contractType[curnt.type],
                        contractorCode: curnt.contractorCode,
                        contractorName: curnt.name,
                        contractorMobile: curnt.mobile,
                        contractorEmail: curnt.email,
                        contractorAddress: getAddressString(curnt.contractorAddress),
                        contractorGSTIN: curnt.gstin,
                        contractorPAN: curnt.pan,
                        numOfVehicles: curnt.tempos_aggregate.aggregate.count,
                        numOfDrivers: curnt.drivers_aggregate.aggregate.count,
                        numOfTempoOrders: curnt.tempoOrders_aggregate.aggregate.count,
                        numOfPickupOrders: '-',
                        totalBilling: '-',
                        duePayment: '-',
                        status: forExport?getContractorStatusString(curnt):curnt.status,
                        action: ''

                    }
                    mainArr.push(curnt.obj)
                })
                if(forExport) return mainArr
                this.hotSettings.data = mainArr
            },
            onAddContractor(){
              this.$refs['contractor-form'].onAddContractor();
            },
            onEditContractor(row){
              this.$refs['contractor-form'].onEditContractor(row);
            },
            onDeleteContractor(contractorId){
              this.$Modal.confirm({
                title: 'Confirmation',
                content: '<p>Are You sure want to delete Contractor ?</p>',
                loading: true,
                onOk: () => {
                  this.deleteContractor(contractorId, this.$Modal)
                }
              });
            },
            deleteContractor(contractorId, callback){
              this.$apollo.mutate({
                mutation: DELETE_CONTRACTOR,
                variables: { contractorId: contractorId }
              }).then(function(response){
                callback.remove();
                this.$Message.success('Contractor deleted successfully!');
              }).catch(function(err){
                callback.remove();
              })
            },
            async exportContractors(){
              this.exportLoading = true
              let re = /<\/?[^>]+(>|$)/g;                  //Remove html tags if any
              let str = this.columns.filter(h => !h.excludeInExport).map(h=> h.title.replace(re,"")).join(',') + '\n'
              let {data:{contractor}} = await this.$apollo.query({
                query: GET_ALL_CONTRACTORS,
                fetchPolicy: 'network-only',
                variables: { city: this.selectedCity, searchFilter: '%' + this.globalSearch + '%' }
              })
              contractor = this.prepareSheetData(contractor, true)
              let dataKeys = this.columns.filter(h => !h.excludeInExport).map(h=> h.data)
              contractor.forEach(c => {
                dataKeys.forEach(k => str = str + '\"' + c[k] + '\"' + ',')               //double quotes to avoid commas within string
                str = str + '\n'
              })

              let blob = new Blob([str], {type: 'text/plain'});
              const a = window.document.createElement('a');
              a.href = window.URL.createObjectURL(blob);
              a.download = 'Contractors_' + moment().format('DD_MMM_YYYY_HH_mm') +'.csv';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              this.exportLoading = false
            }
        },
        mounted(){
            setTimeout(() => {
                this.skipContractors = false
            }, 500)
        }
    }
</script>

<style scoped>
    /deep/  .ivu-spin-fix {
        top: 43px;
        left: 16px;
        z-index: 8;
        width: 86vw;
        height: 40vh;
    }
    /deep/ .handsontable > .ht_master{
        font-size: 14px;
    }
    /deep/ .handsontable > .ht_master > .wtHolder{
        /*width: 100% !important;*/
        width: unset !important;
        height: unset !important;
    }
    .filterInput{
        width: 80%;
    }
    .refresh-icon{
        float: right;
        margin: 9px 16px;
        font-size: 14px;
        cursor: pointer;
    }
    /deep/ .handsontable span.colHeader {
        font-size: 13px;
    }
    /deep/.handsontable td{
        vertical-align: middle !important;
        padding: 0 1px 0 1px !important;
        white-space: unset !important;
        font-size: 13px;
    }

    /deep/.handsontable th{
        background-color: #d9d9d9;
        color: #222;
        text-align: center;
        font-weight: 600;
        vertical-align: middle !important;
        white-space: nowrap !important;
        padding: 0 0px 0 0px !important;
    }
</style>
<style>
    .order-num-txt:hover {
        text-decoration: underline;
    }
    .address-txt{
        width: 145px;
        white-space: nowrap;
        overflow: hidden;
        display: inline-block;
        text-overflow: ellipsis;
        /*border: 1px solid #ddd;*/
        margin: 0px 0px 0px 5px;
    }
  .action-edit{
    font-size: 12px;
    color:grey;
    margin-right:15px;
    cursor: pointer;
  }
  .action-delete{
    font-size: 12px;
    color:red;
    cursor: pointer;
  }
  .action-delete:hover{
    color: #FF8C00;
  }
  .action-edit:hover{
    color: #c0c0c0;
  }
</style>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>
